import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";
const MRPRateCardForm = (props) => {
  const frmRef = useRef({});
  var d = new Date();

  const [cropVarietyData, setCropVarietyData] = useState([]);
  const [croptypeId, setCroptypeId] = useState([]);

  const [cropId, setCropId] = useState([]);
  const [varietyId, setVarietyId] = useState([]);

  const [productData, setProductData] = useState([]);

  const [cropTypeList, setCropTypeList] = useState([]);
  const [cropList, setCropList] = useState([]);
  const [cropFilterList, setCropFilterList] = useState([]);

  const cropTypeOnchangedHandler = (event) => {
    var croptype = event.target.value;
    setCroptypeId(event.target.value);
    setCropFilterList([]);

    const cropFilterList = cropList.filter(
      (item) => parseInt(item.croptypeId) === parseInt(croptype)
    );

    setCropFilterList(cropFilterList);
  };

  const [varietyFilterList, setvarietyFilterList] = useState([]);

  const cropOnchangedHandler = (event) => {
    var crop_Id = event.target.value;
    setCropId(event.target.value);
    var varietyLis = cropVarietyData.filter((item) => item.cropId == crop_Id);

    setvarietyFilterList(varietyLis);
  };

  const [productFilterList, setproductFilterList] = useState([]);

  const varietyOnchangedHandler = (event) => {
    var variety_Id = event.target.value;
    setVarietyId(variety_Id);
    var productFilterList = productData.filter(
      (item) => item.varietyId == variety_Id
    );

    var i = 0;
    var newList = [];
    setproductFilterList([]);

    do {
      var productItem = productFilterList && productFilterList[i];
      var newList = newList.concat({
        linesrno: i + 1,
        salesPriceDate:
          d.getDate() +
          "/" +
          d.getMonth() +
          "/" +
          d.getFullYear() +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes() +
          ":" +
          d.getSeconds(),
        itemUnitPrice: productItem.hasOwnProperty("itemUnitPrice")
          ? productItem.itemUnitPrice
          : 0,
        productId: productItem.productId,
        discount: productItem.hasOwnProperty("discount")
          ? productItem.discount
          : 0,
        itemId: productItem.itemId,

        productName: productItem.productName,
        productSubTypeName: productItem.productSubTypeName,
        productTypeNo: productItem.productTypeNo,
        productTypeName: productItem.productTypeName,
        productSubType: productItem.productSubType,
        unitName: productItem.unitName,
        unitAbbreviation: productItem.unitAbbreviation,
        createdDate:
          d.getDate() +
          "/" +
          d.getMonth() +
          "/" +
          d.getFullYear() +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes() +
          ":" +
          d.getSeconds(),
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        entryTime: d.getHours() + ":" + d.getMinutes(),
         
      });

      i++;
    } while (productFilterList.length  > i);

    setproductFilterList(newList);
  };

  const { sendRequest: getcropType } = useHttp();
  useEffect(() => {
    getcropType(
      {
        url: "/api/croptypes/",
      },
      (res) => {
        if (res) {
          setCropTypeList(res);
        }
      }
    );
  }, [getcropType]);

  const { sendRequest: getcrop } = useHttp();
  useEffect(() => {
    getcrop(
      {
        url: "/api/crops/",
      },
      (res) => {
        if (res) {
          setCropList(res);
        }
      }
    );
  }, [getcrop]);

  const { sendRequest: getcropVariety } = useHttp();

  const getCropVarietyDetail = () => {
    getcropVariety(
      {
        url: `/api/varieties/`,
      },
      (res) => {
        if (res) {
          setCropVarietyData(res);
        }
      }
    );
  };

  useEffect(() => {
    getCropVarietyDetail(0);
  }, [getcropVariety]);

  const { sendRequest: getproduct } = useHttp();

  const fillProduct = () => {
    getproduct(
      {
        url: `/api/product/`,
      },
      (res) => {
        setProductData(res);
      }
    );
  };

  useEffect(() => {
    fillProduct(0);
  }, [getproduct]);

  const { sendRequest: postRateCard } = useHttp();

  const rateCardsubmitHandler = (e) => {
    e.preventDefault();
    const data = {
      salesPrices: productFilterList,
      serviceId: props.sId,orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
    };

 
    postRateCard(
      {
        url: "/api/salesPriceMaster/",
        // method: props.update ? "PUT" : "POST",
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(`Rate card detail added"`);
        props.addForm(false);
      }
    );
  };

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={rateCardsubmitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">MRP Rate Card Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Crop Type</label>
                        <select
                          id="cropTypeNameId"
                          className="form-control"
                          ref={(el) => (frmRef.current["cropTypeNameId"] = el)}
                          value={croptypeId}
                          onChange={cropTypeOnchangedHandler}
                          required
                        >
                          <option value="">Select Crop Type</option>
                          {cropTypeList &&
                            cropTypeList.map((x) => (
                              <option
                                key={x.croptypeId}
                                croptype-id={x.croptypeId}
                                value={x.croptypeId}
                              >
                                {x.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Crop Name </label>
                        <select
                          id="cropNameId"
                          className="form-control"
                          ref={(el) => (frmRef.current["cropId"] = el)}
                          value={cropId}
                          onChange={cropOnchangedHandler}
                          required
                        >
                          <option value="">Select Crop</option>
                          {cropFilterList &&
                            cropFilterList.map((x) => (
                              <option
                                key={x.cropId}
                                crop-id={x.cropId}
                                value={x.cropId}
                              >
                                {x.cropName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Variety Name </label>
                        <select
                          id="varietyId"
                          className="form-control"
                          ref={(el) => (frmRef.current["varietyId"] = el)}
                          value={varietyId}
                          onChange={varietyOnchangedHandler}
                          required
                        >
                          <option value="">Select Variety</option>
                          {varietyFilterList &&
                            varietyFilterList.map((x) => (
                              <option
                                key={x.varietyId}
                                variety-id={x.varietyId}
                                value={x.varietyId}
                              >
                                {x.varietyName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <label>Currency </label>
                        <input
                          type="text"
                          id="currency"
                          className="form-control"
                         value={localStorage.getItem("currencyCode") || ""}
                          readOnly
                        />
                       
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Product Detail </label>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Product Item Type </th>
                          <th>Product Item Subtype </th>
                          <th>Product Name </th>
                          <th>Product No </th>
                          <th>Unit </th>
                          <th>Price Per Unit</th>
                          <th>Discount(%)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {productFilterList &&
                          productFilterList.map((x, i) => (
                            <tr key={i}>
                              <td>
                                {x.productTypeName}( {x.productTypeNo})
                              </td>

                              <td>
                                {x.productSubTypeName}({x.productSubType})
                              </td>

                              <td>{x.productName}</td>

                              <td>{x.itemId}</td>

                              <td>{x.unitName}</td>

                              <td>
                                <input
                                  type={"number"}
                                  id={"PricePerUnit"}
                                  required
                                  ref={(el) =>
                                    (frmRef.current["PricePerUnit"] = el)
                                  }
                                  className="form-control"
                                  defaultValue={
                                    productFilterList[i].itemUnitPrice
                                  }
                                  onChange={(e) => {
                                    productFilterList[i].itemUnitPrice =
                                      e.target.value;
                                    setproductFilterList(productFilterList);
                                  }}
                                />
                              </td>

                              <td>
                                <input
                                  type={"number"}
                                  id={"discount"}
                                  required
                                  ref={(el) =>
                                    (frmRef.current["discount"] = el)
                                  }
                                  className="form-control"
                                  defaultValue={productFilterList[i].discount}
                                  onChange={(e) => {
                                    productFilterList[i].discount =
                                      e.target.value;
                                    setproductFilterList(productFilterList);
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default MRPRateCardForm;
